<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">상품관리</span>
            <span class="txt">센터에서 이용 중인 이용권과 패키지를 등록 및 수정하고 설정할 수 있습니다.</span>
        </div>

        <div class="com-tab">
            <router-link :to="{ name: 'SettingGoodsUse' }">이용권 관리</router-link>
            <router-link :to="{ name: 'SettingGoodsPackage' }" class="on">패키지 관리</router-link>
            <router-link :to="{ name: 'SettingGoodsCategory' }">카테고리 관리</router-link>
        </div>

        <div class="com-search-content">
            <div class="line">
                <div class="com-calendar-wrap">
                    <select-form
                        :select-data="['전체', '판매중', '판매정지']"
                        :select-value="['', 'true', 'false']"
                        :selected-value.sync="filter.stockUseYn"
                        @update:set="(v) => load()"
                    ></select-form>
                </div>
                <div class="com-search-input">
                    <input v-model="filter.searchStr" placeholder="패키지 입력" type="text" @keydown.enter="load" />
                    <button class="search-btn" type="button" @click="load">검색</button>
                </div>
            </div>
        </div>

        <div class="com-btn-area">
            <!--
            고객 요청에 의해서 엑셀 다운로드 기능 삭제
            <div class="left-box">
                <button class="com-btn excel" @click="excelDownload">엑셀 다운로드</button>
            </div>
            -->
            <div class="right-box">
                <router-link :to="{ name: 'SettingGoodsPackageEdit' }" class="com-btn blue">이용권 등록</router-link>
            </div>
        </div>

        <div class="lesson-info-content">
            <loading-spinner v-if="isLoading"></loading-spinner>
            <ul v-else class="list package">
                <li
                    v-for="(item, index) in data.items"
                    :key="index"
                    @click="
                        $router.push({
                            name: 'SettingGoodsPackageEdit',
                            params: { prodNo: item.cp_center_prod_id },
                            query: { page: pagingInfo.page },
                        })
                    "
                >
                    <span v-if="!item.cp_stoc_use_yn" class="no">미사용</span>
                    <span class="icon-box">
                        <span
                            v-for="type in getTicketData(item.cp_ticket_type)"
                            :key="type"
                            :class="'type-' + (ticketData.indexOf(type) + 1)"
                            class="ico"
                        >
                            {{ type }}
                        </span>
                    </span>
                    <span :class="'type-' + (ticketTypes.indexOf(item.cp_ticket_type_cd) + 1)" class="title">
                        {{ item.cp_namee }}
                    </span>
                    <span class="num">
                        {{ item.cp_sell_price | numberFormatFilter }}
                        <small>원</small>
                    </span>
                </li>
            </ul>
        </div>
        <b-pagination
            v-model="pagingInfo.page"
            :per-page="pagingInfo.limit"
            :total-rows="pagingInfo.totalItems"
            align="center"
            aria-controls="my-table"
            first-class="first"
            last-class="last"
            next-class="next"
            prev-class="prev"
            @change="handlerPagenation($event)"
        ></b-pagination>
    </div>
</template>

<script>
import api from '../../../assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { pagingInfo } from '@/assets/js/common';
export default {
    name: 'SettingGoodsPackage',
    components: { LoadingSpinner },
    props: {},
    computed: {
        centerId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    data() {
        return {
            isLoading: false,
            ticketData: [],
            ticketTypes: [],
            filter: {},
            data: [],
            pagingInfo: { ...pagingInfo },
        };
    },
    async beforeMount() {
        this.filter = this.getFilterDefault();
        this.pagingInfo.limit = 12;

        (await this.$getSystemCode({ center_prod: ['ticket_type_cd'] })).forEach((o) => {
            this.ticketData = o.map((e) => e.codeDesc);
            this.ticketTypes = o.map((e) => e.codeName);
        });
    },
    mounted() {
        this.load();
    },
    methods: {
        getFilterDefault() {
            return {
                stockUseYn: 'true',
                sortColumn: 'createAt',
                sortType: 'DESC',
                searchStr: '',
            };
        },
        getTicketData(type) {
            let types = (type || '').split('|');
            types = types.filter((o, i) => types.indexOf(o) === i);
            return types.map((o) => this.ticketData[this.ticketTypes.indexOf(o)]);
        },
        load() {
            api.get(`/admin/api/center/${this.centerId}/product/package`, {
                params: { ...this.pagingInfo, ...this.filter },
            })
                .then((res) => {
                    this.isLoading = false;
                    this.setPageParams(res.data);
                    this.data = res.data;
                })
                .catch((res) => {
                    this.isLoading = false;
                    if (res.response.status != 404) alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
        // 페이지 변경 Handler
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.load();
        },
        /*
        // 엑셀 다운로드 기능
        async excelDownload() {
            let excelDownloadArray = [];
            const { data } = await api.get(`/admin/api/center/${this.centerId}/product/package`, {
                params: {
                    ...this.filter,
                    page: 1,
                    limit: 10000
                }
            });

            data.items.forEach(item => {
                const temp = {};
                temp['패키지명'] = item.cp_namee;
                temp['이용권구분'] = this.getTicketData(item.cp_ticket_type).join(', ');
                temp['금액'] = numberFormat(item.cp_sell_price);

                excelDownloadArray.push(temp);
            });

            //[Key:value, ...]
            const dataWS = XLSX.utils.json_to_sheet(excelDownloadArray);

            // cell width 설정
            const wscols = [
                {wch: 24}, {wch: 24}, {wch: 14}
            ];
            dataWS['!cols'] = wscols;

            // cell height 설정
            const wsrows = [
                {hpx: 30},
            ];
            dataWS['!rows'] = wsrows;

            const wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, dataWS, "패키지관리");
            XLSX.writeFile(wb, '패키지관리.xlsx');
        },
        */
    },
};
</script>
<style lang="scss"></style>
